export const en = {
  title: 'Calendar',
  subtitle: 'Unified calendar view',
  toolbar: {
    views: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
    },
    today: 'Today',
    previous: 'Previous',
    next: 'Next',
    allFacilities: 'All Facilities',
  },
  sidebar: {
    layers: 'Layers',
    colorMode: 'Color Mode',
    status: 'Status',
    retry: 'Retry',
    moduleError: 'Failed to load module data',
    modules: {
      trade: 'Trade',
      transportation: 'Transportation',
      production: 'Production',
      compliance: 'Compliance',
      finance: 'Finance',
      inventory: 'Inventory',
    },
    colorModes: {
      byModule: 'By Module',
      byEntityType: 'By Entity Type',
      byStatus: 'By Status',
    },
  },
  popover: {
    viewDetails: 'View details',
    facility: 'Facility',
    status: 'Status',
    source: 'Source',
  },
  sources: {
    booking: 'Booking',
    load: 'Load',
    salesOrder: 'Sales Order',
    route: 'Route',
    driverCertification: 'Driver Certification',
    workOrder: 'Work Order',
    inboundTolling: 'Inbound Tolling',
    outboundTolling: 'Outbound Tolling',
    dispatchRecord: 'Dispatch Record',
    invoice: 'Invoice',
    bill: 'Bill',
    inventoryMovement: 'Inventory Movement',
  },
  emptyState: {
    noLayers: {
      title: 'No calendar layers enabled',
      description: 'Enable module layers in the sidebar to see events.',
    },
    noEvents: {
      title: 'No events found',
      description: 'No events found in this date range.',
    },
    noAccess: {
      title: 'No access',
      description: "You don't have access to any facilities.",
    },
  },
};
